import React, { useState } from "react";
import * as Yup from "yup";
import {
  Form as BaseForm,
  TextField,
  SelectField,
  SubmitButton,
  CancelPopupButton,
} from "../../../../ui/FormElement";
import { useTopicCategoryContext } from "../../../../contexts/TopicCategoryContext";

import topic_category_types from "../../../../data/topic_category_types";

export default function Form() {
  let FormSchema = Yup.object().shape({
    title: Yup.string().required("Topic Category Name is required"),
    category_type: Yup.string()
      .transform((value) => (value == null ? "" : value))
      .required("Topic Category Type is required"),
  });

  let [loader, setLoader] = useState(false);

  const { dispatch, state, actions } = useTopicCategoryContext();

  const [formData, setFormData] = useState(
    state.currentTopicCategory == null
      ? {
          title: "",
          category_type: "",
        }
      : {
          title: state.currentTopicCategory.attributes.title,
          category_type: state.currentTopicCategory.attributes.category_type,
        }
  );

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);

    actions.saveTopicCategory(
      dispatch,
      state.currentTopicCategory == null
        ? 0
        : parseInt(state.currentTopicCategory.id),
      values,
      () => {
        setLoader(false);
        actions.hideModal(dispatch);
        actions.loadTopicCategories(dispatch);
      },
      (errorData) => {
        let newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace("/data/attributes/", "")] =
            item.detail;
        });
        setErrors(newErrors);
        setLoader(false);
      }
    );
  };

  return (
    <BaseForm
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      <TextField
        name="title"
        label={
          <>
            <span>Topic Category Name</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <SelectField
        label={
          <>
            <span>Topic Category Type</span>
            <abbr title="required">*</abbr>
          </>
        }
        name="category_type"
        options={topic_category_types}
      />

      <div className="text-center mt50 mb30">
        <CancelPopupButton
          className="btn btn-primary btn-outline mr5 ml5 width-120"
          title="Cancel"
          onClick={() => actions.hideModal(dispatch)}
        />
        <SubmitButton
          title={loader ? "Please, wait ..." : "Save"}
          className={`btn width-120 btn-primary submit-button mr5 ml5 ${
            loader ? "not-possible-click" : ""
          }`}
        />
      </div>
    </BaseForm>
  );
}
